import React, { FC, useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { useTheme } from 'styled-components';
import { useTranslate } from '@/translations';
import { useStockByModel } from '@/api/OperationsDashboard';
import { ChartCard } from './ChartCard';

const HEIGHT = 300;

export const StockByModelChart: FC = () => {
  const { t } = useTranslate();
  const { primaryChartColor } = useTheme();
  const { data, isLoading, isError, refetch } = useStockByModel();

  const rows = useMemo(
    () =>
      [...(data ?? [])]
        .map((r) => ({ ...r, category: (r.category ?? '').trim() }))
        .reverse(),
    [data],
  );

  const options: echarts.EChartsOption = useMemo(
    () => ({
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: { left: 8, right: 32, top: 8, bottom: 8, containLabel: true },
      xAxis: { type: 'value' },
      yAxis: {
        type: 'category',
        data: rows.map((r) => r.category),
        axisLabel: {
          width: 130,
          overflow: 'truncate',
          ellipsis: '…',
        },
      },
      series: [
        {
          type: 'bar',
          data: rows.map((r) => r.count),
          itemStyle: { color: primaryChartColor },
          label: { show: true, position: 'right' },
        },
      ],
    }),
    [rows, primaryChartColor],
  );

  return (
    <ChartCard
      title={t('dashboard.widget.stockByModel')}
      isLoading={isLoading}
      isError={isError}
      isEmpty={data?.length === 0}
      onRetry={() => refetch()}
      height={HEIGHT}
    >
      <ReactECharts option={options} style={{ height: HEIGHT }} />
    </ChartCard>
  );
};
